import { GachaOption as GachaOptionGraphql } from 'vvs-gotchi-graphql'

export type GachaponState = 'init' | 'eligible' | 'done'
export type GachaponStep = 'init' | 'select' | 'rolling' | 'result'
export type GachaponOption = 'hp' | 'exp'

export const gachaponOptionToGraphql = (opt: GachaponOption): GachaOptionGraphql => {
  switch (opt) {
    case 'hp':
      return GachaOptionGraphql.Hp
    case 'exp':
      return GachaOptionGraphql.Exp
    default:
      throw new Error('Unknown gachapon type/option')
  }
}
